import apiSettings from './api.settings'
import localeSettings from './locale.settings'
import urlSettings from './url.settings'
import assetSettings from './assets.settings'

// TODO: spread does not work on exports, fix this
const settings = {
  ...apiSettings,
  ...localeSettings,
  ...urlSettings,
  ...assetSettings,
}

export default settings

export * from './locale.settings'
export * from './features.settings'
export * from './assets.settings'
